import React, { Component } from 'react';
import {
  Pagination,
  Categories,
  StoriesListItem,
  SubscribeBlock,
} from '.';
import './StoriesList.scss';

const isClient = typeof window !== 'undefined';
const MOBILE_BREAKPOINT = 800;

class StoriesList extends Component {
  state = {
    viewportWidth: 0,
  };

  componentDidMount() {
    if (isClient) {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }

  componentWillUnmount() {
    if (isClient) window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ viewportWidth: window.innerWidth });
  }

  render() {
    const {
      stories,
      categories,
      settings,
      siteMetadata,
      location,
      pageContext,
      pathPrefix,
    } = this.props;
    const {
      socialLinks,
    } = settings.data;
    const {
      viewportWidth,
    } = this.state;
    const isMobile = Boolean(viewportWidth <= MOBILE_BREAKPOINT);
    // Used to determine whether SubscribeBlock lives in the left or right column
    const evenNumStories = Boolean(stories.length % 2 === 0);
    const leftCol = [];
    const rightCol = [];
    stories.forEach((story, index) => {
      const isEven = Boolean(index % 2 === 0);
      if (isEven) {
        rightCol.push(story);
      } else {
        leftCol.push(story);
      }
    });
    const {
      humanPageNumber,
      numberOfPages,
    } = pageContext;
    const isLastPage = Boolean(humanPageNumber === numberOfPages);
    return (
      <section className="stories-list">
        {isMobile && (
          <div className="stories--mobile-view">
            {categories && (
              <Categories
                categories={categories}
                location={location}
                siteMetadata={siteMetadata}
              />
            )}
            {stories.map(story => (
              <StoriesListItem
                key={story.uid}
                siteMetadata={siteMetadata}
                {...story}
              />
            ))}
            {isLastPage && <SubscribeBlock socialLinks={socialLinks} />}
          </div>
        )}
        {!isMobile && (
          <div className="stories--desktop-view">
            <div className="col left-col">
              {categories && (
                <Categories
                  categories={categories}
                  location={location}
                  siteMetadata={siteMetadata}
                />
              )}
              {(leftCol && leftCol.length > 0) && (
                leftCol.map(story => (
                  <StoriesListItem
                    key={story.uid}
                    siteMetadata={siteMetadata}
                    {...story}
                  />
                ))
              )}
              {(isLastPage && !evenNumStories) && <SubscribeBlock socialLinks={socialLinks} />}
            </div>
            <div className="col right-col">
              {(rightCol && rightCol.length > 0) && (
                rightCol.map(story => (
                  <StoriesListItem
                    key={story.uid}
                    siteMetadata={siteMetadata}
                    {...story}
                  />
                ))
              )}
              {(isLastPage && evenNumStories) && <SubscribeBlock socialLinks={socialLinks} />}
            </div>
          </div>
        )}
        <Pagination
          pageContext={pageContext}
          pathPrefix={pathPrefix}
        />
      </section>
    );
  }
}


export default StoriesList;
